import { BaseNumberIdDataDto } from '../../../classes/common/response/base-number-id-data.dto';
export class ChecklistItemDto extends BaseNumberIdDataDto {
    constructor(initializer) {
        super(initializer);
        this.name = initializer.name;
    }
}
